import type { SVGProps } from 'react';

export function FillUserIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M4.18153 15.5102L4.18155 15.5102L4.17634 15.5062C4.05094 15.4114 3.95952 15.2786 3.91567 15.1276C3.872 14.9772 3.87786 14.8167 3.93237 14.6699C4.40346 13.443 5.23528 12.3877 6.31821 11.643C7.40177 10.8979 8.68578 10.4989 10.0008 10.4986C11.3158 10.4983 12.6 10.8967 13.6839 11.6413C14.7678 12.3859 15.6005 13.4417 16.072 14.6693L16.0723 14.6703C16.1844 14.96 16.0893 15.2996 15.8246 15.5047L15.8239 15.5052C14.2155 16.7555 12.1947 17.5 9.99971 17.5L9.99895 17.5C7.89231 17.5032 5.84492 16.8029 4.18153 15.5102ZM11.7675 6.76777C11.2986 7.23661 10.6628 7.5 9.99971 7.5C9.33667 7.5 8.70078 7.23661 8.23194 6.76777C7.7631 6.29893 7.49971 5.66304 7.49971 5C7.49971 4.33696 7.7631 3.70107 8.23194 3.23223C8.70078 2.76339 9.33667 2.5 9.99971 2.5C10.6628 2.5 11.2986 2.76339 11.7675 3.23223C12.2363 3.70107 12.4997 4.33696 12.4997 5C12.4997 5.66304 12.2363 6.29893 11.7675 6.76777Z'
        fill='currentColor'
        stroke='currentColor'
      />
    </svg>
  );
}
